module.exports = __webpack_public_path__ + "img/home.26d3a293.png";